<template>
  <div class="mx-3">
    <v-container>
      <v-row>
        <v-col class="mx-10"> <h3>Company Management</h3> </v-col></v-row
      >
      <v-card class="main-card ml-2" elevation="0" color="#F0F2F5">
        <v-row class="mx-5">
          <v-col lg="4" sm="6" cols="12" class="py-0">
            <div class="xs-full-width mt-7">
              <p class="mb-2 font-weight-medium subtitle-1">Search</p>
              <v-text-field
                type="text"
                class="text-field-border subtitle-2"
                v-model="searchinfo"
                placeholder="Search"
                clearable
                clear-icon="mdi-close mb-2"
                solo
                dense
                flat
                @change="searchCompanyList(searchinfo)"
              ></v-text-field>
            </div>
          </v-col>
        </v-row>
        <v-row class="ma-5 ml-8">
          <v-col cols="3" lg="3" sm="4">
            <v-row class="mr-2 add-company" @click="dialog = true">
              <v-col cols="12">
                <div class="icon text-center text-md-body-1">
                  <v-icon>mdi-plus</v-icon>
                  <p class="mb-0">Add Company</p>
                </div>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="3" lg="3" sm="4" v-for="company in companies" :key="company._id">
            <v-row
              class="bg-white mr-2 add-company"
              @click="goToDetail(company._id, company.active)"
            >
              <v-col cols="5">
                <v-card elevation="0" class="ml-2">
                  <v-img :src="company.coverImg" aspect-ratio="1" width="60" height="70">
                    <template v-slot:placeholder>
                      <v-row class="fill-height ma-0" align="center" justify="center">
                        <v-progress-circular
                          indeterminate
                          color="grey lighten-5"
                        ></v-progress-circular>
                      </v-row>
                    </template>
                  </v-img>
                </v-card>
              </v-col>
              <v-col cols="7">
                <div class="font-weight-bold text-sm-body-2 title-company pr-2">
                  {{ company.title }}
                </div>
                <div class="company-active d-flex mt-2">
                  <div
                    class="dot mt-7px mr-3"
                    :style="{
                      background: company.active ? 'rgb(72, 222, 78)' : '#f44336',
                    }"
                  ></div>
                  <span class="text-sm-body-2 title-company text-active">{{
                    company.active ? "เปิดการใช้งาน" : "ปิดการใช้งาน"
                  }}</span>
                </div>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-pagination
          v-model="params.page"
          :length="countPage"
          @input="changePage"
        ></v-pagination>
      </v-card>
      <v-dialog v-model="dialog" width="450">
        <v-card>
          <v-toolbar dark color="rgb(51, 97, 137)">
            <v-toolbar-title class="font-weight-light pl-2">Add Company</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon dark @click="clearData">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar>
          <v-card-text class="pt-5">
            <warnningComponent
              :textInfo.sync="textWarning"
              :typestatus.sync="typeWarning"
              :alert.sync="showWarnnig"
            ></warnningComponent>
            <p class="mb-2 body-1 font-weight-bold">Company Information</p>
            <v-form ref="form" v-model="valid">
              <v-row>
                <v-col cols="12" md="12" class="py-0">
                  <p class="mb-2 body-2">
                    Company's Name<span class="error--text">*</span>
                  </p>
                  <v-text-field
                    outlined
                    placeholder="Company's Name"
                    :rules="companyNameRules"
                    v-model="company.title"
                    required
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" md="12" class="py-0">
                  <p class="mb-2 body-2">Domain Name<span class="error--text">*</span></p>
                  <v-text-field
                    outlined
                    placeholder="Domain Name"
                    v-model="company.domainName"
                    :rules="domainNameRule"
                    required
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-divider class="mb-5"></v-divider>
              <p class="mb-2 body-1 font-weight-bold">Admin Account</p>
              <v-row>
                <v-col cols="12" md="12" class="py-0">
                  <p class="mb-2 body-2">Email<span class="error--text">*</span></p>
                  <v-text-field
                    outlined
                    placeholder="System Email"
                    :rules="emailRules"
                    v-model="company.systemEmail"
                    required
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" md="12" class="py-0">
                  <p class="mb-2 body-2">Password<span class="error--text">*</span></p>

                  <v-text-field
                    outlined
                    :value="password"
                    v-model="company.password"
                    height="40px"
                    name="password"
                    id="password"
                    :type="value ? 'text' : 'password'"
                    @click:append="() => (value = !value)"
                    :append-icon="!value ? 'mdi-eye' : 'mdi-eye-off'"
                    autocomplete="password"
                    :rules="passwordRules"
                    placeholder="Password"
                    required
                    clearable
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <div class="float-right">
                    <v-btn
                      class="mr-3 pl-10 pr-10 font-weight-regular text-capitalize"
                      outlined
                      @click="clearData"
                      >Cancel</v-btn
                    >
                    <v-btn
                      class="pl-10 pr-10 font-weight-regular text-capitalize"
                      dark
                      color="rgb(66, 154, 216)"
                      @click="addcompany"
                      >Submit</v-btn
                    >
                  </div>
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>
        </v-card>
      </v-dialog>

      <loadingDialog v-bind:ld_dialog.sync="loadingDialog"></loadingDialog>
      <completeDialog
        v-bind:cm_dialog.sync="completeWarning.isShow"
        v-bind:cm_title="completeWarning.title"
        v-bind:cm_text="completeWarning.text"
        v-bind:cm_color="completeWarning.colorBtn"
        @done="closeSuccesDialog"
      ></completeDialog>
    </v-container>
  </div>
</template>
<script>
import { cleaningData } from "@/helper/cleaningData";
import loadingDialog from "@/components/loadingDialog";
import completeDialog from "@/components/completeDialog";
import warnningComponent from "@/components/warningAlert";
import { fetchCompayList, insertCompany, insertCompanyAndInsertMenu } from "@/service/company/company";
import { registerAdmin } from "@/service/account/manageUser";
import { login } from "@/service/account/login";
import { checkDevice } from "@/helper/checkDevice";
import { getInfo } from "@/service/account/login";
import { insertUserGroup } from "@/service/account/manageUserGroup";
import { insertMenuCompany } from "@/service/company/setting";
// item default company tabbars when insert
import itemTypeTabbars from "@/views/company/default_tabbars.json";
export default {
  name: "company",
  components: {
    warnningComponent,
    loadingDialog,
    completeDialog,
  },
  data() {
    return {
      valid: true,
      loadingDialog: false,
      completeWarning: {
        isShow: false,
        title: "",
        text: "",
        colorBtn: "",
      },
      //add company
      company: {
        domainName: "",
        title: "",
        systemEmail: "",
        password: "",
      },
      passwordRules: [(v) => !!v || "Password is required"],
      companyNameRules: [
        (v) => !!v || "Company Name  is required",
        (v) =>
          (v && v.length <= 50) || "Cateogry Name must be less or equal to 50 characters",
      ],
      emailRules: [
        (v) => !!v || "E-mail is required",
        (v) => /.+@.+\..+/.test(v) || "E-mail must be valid",
      ],
      domainNameRule: [(v) => !!v || "Sub Domain Name is required"],
      companies: [],
      //tab
      tab: "detail",
      params: {
        page: 1,
        limit: 15,
        search: "",
        sort: "created_at",
        sortby: "-1",
      },
      searchinfo: "",
      countPage: 1,
      dialog: false,

      //warrning
      textWarning: "",
      typeWarning: "",
      showWarnnig: false,

      //company active
      active: false,
      value: false,
    };
  },
  mounted() {
    this.getCompanyList();
  },
  watch: {
    searchinfo(keyword) {
      this.searchCompanyList(keyword);
    },
    dialog(value) {
      if (!value) {
        this.clearData();
      }
    },
  },
  methods: {
    async getCompanyList() {
      let itemList = await fetchCompayList(this.params);
      this.companies = [];
      this.countPage = itemList.maxPage;
      itemList.data.map((item) => {
        this.companies.push(item.companies);
      });
    },
    searchCompanyList(keyword) {
      this.params.search = keyword;
      this.params.page = 1;
      this.getCompanyList();
    },
    async changePage(page) {
      this.page = page;
      this.params.page = this.page;
      await this.getCompanyList();
    },
    clearData() {
      this.$refs.form.resetValidation();
      this.$refs.form.reset();
      this.dialog = false;
    },
    async addcompany() {
      if (this.$refs.form.validate()) {
        this.company.title = cleaningData(this.company.title);
        let insertStatus = await insertCompanyAndInsertMenu(this.company);
        if (insertStatus.message == "domain duplicate") {
          this.alertCompleteDialog("Domain duplicate", "", "error");
        } else if (insertStatus.code == 403) {
          this.alertCompleteDialog("กรุณากรอกข้อมูลให้ถูกต้อง", "", "error");
        } else {
          this.loadingDialog = true;
          let oldToken = await localStorage.getItem("x-session-token");
          let insertUserStatus = await this.insertUserCompany(insertStatus);
          await this.signin(insertUserStatus);
          await localStorage.setItem("x-session-token", oldToken);
          await this.clearData();
          // await this.insertCompanyTabbars(insertStatus._id);
          // this.warnnig("Add New Company Success", "success");
          await this.goToDetail(insertStatus._id, true);
          this.loadingDialog = false;
        }
      }
      // if (this.$refs.form.validate()) {
      //   this.company.title = cleaningData(this.company.title);
      //   let insertStatus = await insertCompany(this.company);
      //   if (insertStatus.message == "domain duplicate") {
      //     // this.warnnig("Domain duplicate", "error");
      //     this.alertCompleteDialog("Domain duplicate", "", "error");
      //   } else if (insertStatus.code == 403) {
      //     // this.warnnig("กรุณากรอกข้อมูลให้ถูกต้อง", "error");
      //     this.alertCompleteDialog("กรุณากรอกข้อมูลให้ถูกต้อง", "", "error");
      //   } else {
      //     this.loadingDialog = true;
      //     let oldToken = await localStorage.getItem("x-session-token");
      //     let insertUserStatus = await this.insertUserCompany(insertStatus);
      //     await this.signin(insertUserStatus);
      //     // await this.insertUserGroup();
      //     await localStorage.setItem("x-session-token", oldToken);
      //     await this.clearData();
      //     await this.insertCompanyTabbars(insertStatus._id);
      //     this.warnnig("Add New Company Success", "success");
      //     await this.goToDetail(insertStatus._id, true);
      //     this.loadingDialog = false;
      //   }
      // }
    },
    async insertUserCompany(value) {
      let status = await registerAdmin({
        username: this.company.systemEmail,
        password: this.company.password,
        firstName: "Admin",
        lastName: this.company.title,
        image: "",
        studentCode: "",
        gender: "male",
        email: this.company.systemEmail,
        identificationNumber: "",
        companies: [value._id], //
        user_groups: [],
        isTeacher: "y",
        permission: {
          adminCompany: true,
          viewTutor: true,
          viewStudent: true, //ข้อมูลผู้ใช้
          insertStudent: true, //เพิ่มรายชื่อ
          updateStudent: true, //แก้ไขรายชื่อผู้ใช้
          activeStudent: true, //ระงับการใช้งาน
          viewCourse: true, //เข้าถึงคอร์ส
          insertCourse: true, //เพิ่มคอร์ส
          updateCourse: true, //แก้ไขคอร์ส
          activeCourse: true, //ระงับคอร์ส
          viewCategory: true, //จัดการ Category
          insertCategory: true, //จัดการ Category
          updateCategory: true, //จัดการ Category
          activeCategory: true, //จัดการ Category
          viewBanner: true, //จัดการ Banner
          insertBanner: true, //จัดการ Banner
          updateBanner: true, //จัดการ Banner
          activeBanner: true, //จัดการ Banner
          viewReport: true, //เข้าถึงการรายงาน
          viewCompany: false,
          insertCompany: false,
          updateCompany: false,
          activeCompany: false,
          viewUserGroup: true, //จัดการกลุ่มผู้ใช้
          insertUserGroup: true, //จัดการกลุ่มผู้ใช้
          updateUserGroup: true, //จัดการกลุ่มผู้ใช้
          activeUserGroup: true, //จัดการกลุ่มผู้ใช้
          accessBI: false,
        },
      });
      return status;
    },
    async signin(value) {
      let device = checkDevice();
      let result = await login({
        id: value._id,
        password: this.company.password,
        platform: device.platform,
        osversion: device.osversion,
        device: device.device,
      });

      if (result.data.status == false) {
        this.loading = false;

        this.warnnig("รหัสผ่านไม่ถูกต้อง", "warning");
        return;
      } else {
        this.loading = false;

        await localStorage.setItem("x-session-token", result.data.result.token);
        await localStorage.setItem("expWeb", result.data.result.endTime);

        let resultInfo = await getInfo();
        console.log("result Info user: ", resultInfo);
      }
      return result;
    },
    async insertUserGroup() {
      let result = await insertUserGroup({
        title: "B2C",
        levelSub: 1,
        active: false,
        externalAccess: true,
      });
      if (result.status == false) {
        this.warnnig("เพิ่มกลุ่มผู้ใช้ไม่สำเร็จ", "warning");
        return;
      }
      return result;
    },
    insertCompanyTabbars(id) {
      itemTypeTabbars.forEach((item, idx) => {
        let params = {
          company: id,
          type: item.type,
          name: item.name,
          icon: item.icon,
          setting: item.setting,
        };
        let result = insertMenuCompany(params);
      });
    },
    goToDetail(id, active) {
      this.$router.push({
        path: "/company/detail",
        query: { id: id, active: active },
      });
    },
    warnnig(text, type) {
      (this.textWarning = text), (this.typeWarning = type), (this.showWarnnig = true);
      setInterval(() => {
        this.showWarnnig = false;
      }, 5000);
    },
    closeSuccesDialog(value) {
      this.completeWarning.isShow = value;
    },
    alertCompleteDialog(title, text = "", color = "success") {
      this.completeWarning.isShow = true;
      this.completeWarning.title = title;
      this.completeWarning.text = text;
      this.completeWarning.colorBtn = color;
    },
  },
};
</script>

<style scoped>
.custom-border {
  border: 1px solid #ccc !important;
}
.main-card {
  width: 90%;
  background: #f0f2f5;
}
.add-company {
  width: 100%;
  border: 1px solid #e0e0e0;
  height: 107px;
  position: relative;
  cursor: pointer;
}
.text-caption {
  color: #9b9b9b;
}
.text-active {
  color: #575757;
}
.icon {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.w-md-30 {
  width: 30%;
}
.bg-white {
  background: #fff;
  /* height: 100px; */
}
.title-company {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  line-height: normal;
}
.dot {
  width: 10px;
  height: 10px;
  border-radius: 10px;
}
.mt-7px {
  margin-top: 6px !important;
}
.text-field-border {
  border: 1px solid;
  border-color: rgba(65, 65, 65, 0.3);
  background-color: white;
  height: 40px;
  color: rgb(77, 77, 77);
}
</style>
